import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const NotificationController = {
    BaseModel: { 
        id: "string",
        createdAt: "2023-08-11T18:14:50.464Z",
        updatedAt: "2023-08-11T18:14:50.464Z",
        userId: "string",
        title: "string",
        body: "string",
        imageUrl: "string",
        data: [
            {
                id: "string",
                createdAt: "2023-08-11T18:14:50.464Z",
                updatedAt: "2023-08-11T18:14:50.464Z",
                notificationId: "string",
                key: "string",
                value: "string"
            }
        ],
        seen: true
    },

    Update: async function (data, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `notification/${data.id}`,
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Delete: async function (id, response, error){
        await BaseService(
            {
              method: "DELETE",
              url: `notification/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    List: async function (response, error){
        await BaseService(
            {
              method: "GET",
              url: `notification/`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },
    
}